/**
 * Barcode URL builder — points at the server-side /api/barcode.php engine.
 * SVG is used for crisp browser/print rendering; PNG is fetched and embedded
 * in the PDF. Same engine, one source of truth.
 */

import { BarcodeSymbology } from '../types';

const API_URL = process.env.REACT_APP_API_URL || '';

export function buildBarcodeUrl(
  data: string,
  symbology: BarcodeSymbology,
  format: 'svg' | 'png',
  heightPx?: number,
): string {
  const params = new URLSearchParams({ type: symbology, data, format });
  if (heightPx && heightPx > 0) params.set('height', String(Math.round(heightPx)));
  return `${API_URL}/api/barcode.php?${params.toString()}`;
}

export const BARCODE_SYMBOLOGIES: { value: BarcodeSymbology; label: string }[] = [
  { value: 'code128', label: 'Code 128 (alphanumeric)' },
  { value: 'upca', label: 'UPC-A (12 digits)' },
  { value: 'ean13', label: 'EAN-13 (13 digits)' },
  { value: 'ean8', label: 'EAN-8 (8 digits)' },
];
